import { styled, keyframes, Flex } from '@withjoy/joykit';

export const StyledLoadingWrapper = styled(Flex)``;

// loaderWidth * strokeWidth * 4 sides
const spinnerSize = 52;
const loading = keyframes`
    0% {
        transform: rotate(0deg);
        stroke-dashoffset: ${0.66 * spinnerSize};
    } 50% {
        transform: rotate(720deg);
        stroke-dashoffset: ${3.14 * spinnerSize};
    } 100% {
        transform: rotate(1080deg);
        stroke-dashoffset:  ${0.66 * spinnerSize};
    }
`;

export const StyledLoader = styled.circle`
  fill: transparent;
  stroke: ${props => props.theme.colors.mono14};
  stroke-width: 4;
  stroke-linecap: round;
  stroke-dasharray: ${3.14 * spinnerSize};
  transform-origin: ${0.5 * spinnerSize}px ${0.5 * spinnerSize}px;
  animation: ${loading} 2s linear infinite;
`;
